import React from 'react';
import { classNames, layoutClassNames, LayoutClassNameProps } from '../atoms';

export interface PageProps extends React.HTMLAttributes<HTMLDivElement>, LayoutClassNameProps {
  fluid?: boolean;
}

const Page: React.FC<PageProps> = ({
  fluid = false,
  className,
  children,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  ...props
}) => (
  <div
    className={classNames(
      fluid ? 'container-fluid' : 'container',
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

export default Page;
